<!---- HORIZONTAL ---->
<ng-container *ngIf="horizontal">
  <svg:g *ngFor="let path of getSelectedTrainrunPaths()">
    <svg:g [attr.transform]="'translate(' + getTranslateX(path) + ',' + 0 + ')'">
      <ng-container *ngIf="!renderTrackLabels">
        <ng-container *ngIf="!renderOnlyGrid">
          <svg:g *ngIf="path.isNode()">
            <ng-container *ngIf="!isStartOrEndNode(path) || path.index !== 0">
              <svg:line
                [class]="getClassTag('PathGridLine', path)"
                x1="0"
                y1="-1000000000"
                x2="0"
                y2="1000000000"
              />
            </ng-container>
            <ng-container *ngIf="!isStartOrEndNode(path) || path.index === 0">
              <svg:g *ngIf="isTrackOccupier(path)">
                <svg:line
                  [class]="getClassTag('PathGridLine', path)"
                  [attr.x1]="nodeWidth(path) - 1"
                  y1="-1000000000"
                  [attr.x2]="nodeWidth(path) - 1"
                  y2="1000000000"
                />
              </svg:g>
            </ng-container>
          </svg:g>
        </ng-container>
        <ng-container *ngIf="renderOnlyGrid">
          <svg:g *ngIf="isTrackOccupier(path)">
            <rect
              class="TrackOccupierShown"
              x="1"
              [attr.y]="viewBoxChangeInfo.y"
              [attr.width]="nodeWidth(path) - 1"
              [attr.height]="viewBoxChangeInfo.height"
            />

            <svg:line
              *ngFor="let gridTrackPos of getGridTrackPositions(path)"
              [class]="getClassTagWithTrackPos('TrackGridLine ', path, gridTrackPos)"
              [attr.x1]="gridTrackPos"
              y1="-1000000000"
              [attr.x2]="gridTrackPos"
              y2="1000000000"
            />
          </svg:g>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="renderTrackLabels">
        <svg:g *ngIf="isTrackOccupier(path)">
          <rect
            class="TrackOccupierShown"
            x="1"
            [attr.y]="viewBoxChangeInfo.y"
            [attr.width]="nodeWidth(path) - 1"
            [attr.height]="viewBoxChangeInfo.height"
          />

          <svg:line
            *ngFor="let gridTrackPos of getGridTrackPositions(path)"
            [class]="getClassTagWithTrackPos('TrackGridLine ', path, gridTrackPos)"
            [attr.x1]="gridTrackPos"
            [attr.y1]="getRenderLabelPosY(gridTrackPos, false)"
            [attr.x2]="gridTrackPos"
            [attr.y2]="40"
          />

          <ng-container *ngFor="let gridTrackPos of getGridTrackPositions(path)">
            <svg:g
              [attr.transform]="
                'translate(' + gridTrackPos + ',' + getRenderLabelPosY(gridTrackPos, true) + ')'
              "
            >
              <svg:text
                [class]="getClassTagWithTrackPos('TrackGridLabelText ', path, gridTrackPos)"
                [attr.x]="0"
                [attr.y]="0"
              >
                {{ getTrackLabel(gridTrackPos) }}
                <title>
                  {{ getTrackTitel(path, gridTrackPos) }}
                </title>
              </svg:text>
            </svg:g>
          </ng-container>
        </svg:g>
      </ng-container>
    </svg:g>
  </svg:g>
</ng-container>

<!---- VERTICAL ---->
<ng-container *ngIf="!horizontal">
  <svg:g></svg:g>
</ng-container>
